import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-dwg',
  templateUrl: './dwg.html',
  styleUrl: './dwg.scss',
})
export class Dwg {
  width = input<string>('1rem');
  height = input<string>('1rem');
}
